import { FC } from "react";
import { useField, useForm } from "react-final-form";

import { Stack } from "@bps/fluent-ui";
import { useStores } from "@stores/hooks/useStores.ts";
import { CheckboxField } from "@ui-components/form/CheckboxField.tsx";
import { DropdownField } from "@ui-components/form/DropdownField.tsx";
import { FieldCondition } from "@ui-components/form/FieldCondition.tsx";
import { FieldSpy } from "@ui-components/form/FieldSpy.tsx";

import {
  empContactMethodsNameOf,
  EmployersContactMethodsValues
} from "./contact-methods/ChooseOrganisationDialog.tsx";
import { dropdownStyle } from "./employers/Employers.styles.ts";

export const EmployerFields: FC = () => {
  const { practice } = useStores();

  const {
    input: { value: currentJob }
  } = useField<boolean>(empContactMethodsNameOf("currentJob"), {
    subscription: { value: true }
  });

  const form = useForm<EmployersContactMethodsValues>();

  return (
    <FieldCondition when={empContactMethodsNameOf("saveAsEmployer")} is={true}>
      <Stack
        tokens={{ childrenGap: 8 }}
        styles={(_props, theme) => ({
          root: {
            border: `1px solid ${theme.palette.neutralLight}`,
            borderRadius: "2px",
            padding: 8,
            marginBottom: 16
          }
        })}
      >
        <Stack horizontal verticalAlign="end" tokens={{ childrenGap: 8 }}>
          <DropdownField
            label="Employment type"
            options={practice.ref.employeeTypes.keyTextValues}
            styles={dropdownStyle}
            name={empContactMethodsNameOf("employmentType")}
          />
          <CheckboxField
            name={empContactMethodsNameOf("primaryEmployer")}
            label="Primary employer"
            disabled={!currentJob}
            styles={{
              root: { paddingBottom: 6 }
            }}
          />
          <FieldSpy
            name={empContactMethodsNameOf("currentJob")}
            onChange={value => {
              if (!value) {
                form.change(empContactMethodsNameOf("primaryEmployer"), false);
              }
            }}
          />
        </Stack>
        <CheckboxField
          name={empContactMethodsNameOf("currentJob")}
          label="Currently works here"
        />
      </Stack>
    </FieldCondition>
  );
};
